import React from "react";
import { Link } from "react-router-dom";

export default function Homepage() {
  return (
    <div>
      <Link to={"/accounts/login/"}>Login</Link>
    </div>
  );
}
